
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router';
import { Dialog } from 'radix-ui';
import { Menu, X } from 'lucide-react';

import AppSidebar from './AppSidebar.jsx';
import AccountMenu from './AccountMenu.jsx';
import ThemeToggle from '../ui/ThemeToggle.jsx';

export default function AppHeader() {
	const [mobileOpen, setMobileOpen] = useState(false);
	const { pathname } = useLocation();

	useEffect(() => {
		setMobileOpen(false);
	}, [pathname]);

	useEffect(() => {
		const media = window.matchMedia('(min-width: 64rem)');

		const handleResize = () => {
			if (media.matches)
				setMobileOpen(false);
		};

		media.addEventListener('change', handleResize);
		return () => media.removeEventListener('change', handleResize);
	}, []);

	return (
		<Dialog.Root open={mobileOpen} onOpenChange={setMobileOpen}>
			<header className="sticky top-0 z-30 flex h-18 shrink-0 items-center justify-between border-b border-zinc-200/90 bg-white/95 px-3 shadow-[0_1px_3px_rgba(0,0,0,0.025)] backdrop-blur-xl dark:border-white/[0.08] dark:bg-[#111216]/95 dark:shadow-none sm:px-5 lg:px-8">
				<div className="flex min-w-0 items-center gap-3">
					<Dialog.Trigger asChild>
						<button type="button" aria-label="Deschide meniul" className="flex size-11 shrink-0 items-center justify-center rounded-xl text-zinc-700 outline-none transition-colors hover:bg-zinc-100 focus-visible:ring-2 focus-visible:ring-brand-500 dark:text-zinc-200 dark:hover:bg-white/10 lg:hidden">
							<Menu size={21} strokeWidth={1.8} />
						</button>
					</Dialog.Trigger>

					<Link to="/" aria-label="Dashboard" className="flex h-10 items-center rounded-xl bg-[#0c0d0f] px-2.5 outline-none focus-visible:ring-2 focus-visible:ring-brand-500 lg:hidden">
						<img src="/assets/imgs/logo.svg" alt="Ride app" className="block h-auto w-24 sm:w-28" />
					</Link>

					<div className="hidden lg:block">
						<p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-zinc-500 dark:text-zinc-400">
							Management
						</p>
						<p className="mt-0.5 text-sm font-semibold tracking-tight text-zinc-950 dark:text-white">
							Panou de administrare
						</p>
					</div>
				</div>

				<div className="flex shrink-0 items-center gap-1 sm:gap-2">
					<ThemeToggle />

					<div className="mx-1 h-6 w-px bg-zinc-200 dark:bg-white/10" />

					<AccountMenu />
				</div>
			</header>

			<Dialog.Portal>
				<Dialog.Overlay className="fixed inset-0 z-40 bg-black/65 backdrop-blur-[2px] lg:hidden" />

				<Dialog.Content aria-describedby={undefined} className="fixed inset-y-0 left-0 z-50 w-80 max-w-[85vw] border-r border-white/10 bg-[#0c0d0f] text-white shadow-2xl outline-none lg:hidden">
					<Dialog.Title className="sr-only">Navigare principală</Dialog.Title>

					<Dialog.Close asChild>
						<button type="button" aria-label="Închide meniul" className="absolute right-3 top-6 z-10 flex size-11 items-center justify-center rounded-xl text-white/65 outline-none transition-colors hover:bg-white/10 hover:text-white focus-visible:ring-2 focus-visible:ring-brand-500">
							<X size={21} strokeWidth={1.8} />
						</button>
					</Dialog.Close>

					<AppSidebar onNavigate={() => setMobileOpen(false)} />
				</Dialog.Content>
			</Dialog.Portal>
		</Dialog.Root>
	);
}